import { Outlet } from 'react-router-dom';

export default function MethodsRequested() {
    return (
        <Outlet />
    )
}
